import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { connectWallet } from "../../../Contract/utils";
import { useConnect, useDisconnect, useAccount, useSwitchChain } from "wagmi";
import { Dropdown } from "react-bootstrap";
import chainConfig from "../../../Provider/chainConfig";
import WalletModal from "./Modal/WalletModal";

const Header = () => {
  // const { connectors, connect } = useConnect();
  // const { isConnected, address } = useAccount();
  // const { disconnect } = useDisconnect();

  // const { chain } = useAccount();
  // const { switchChain } = useSwitchChain();

  // useEffect(() => {
  //   if (isConnected && chain && chain.id) {
  //     const targetChainId = chainConfig[11155111].id;

  //     if (chain.id !== targetChainId) {
  //       switchChain({ chainId: targetChainId });
  //     }
  //   }
  // }, [chain, isConnected]);

  // const handleDisconnect = () => {
  //   disconnect();
  //   console.log("Wallet disconnected!");
  // };

  const files = [
    { name: "ZFORGE-WHITEPAPER", url: "/images/ZFORGE-WHITEPAPER.pdf" },
  ];
  const downloadFiles = () => {
    files.forEach((file) => {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Navbar expand="lg" className="custom-header">
        <Container>
          <div className="header">
            <Navbar.Brand>
              <Link to="/">
                <img src="/images/logo.png" alt="" />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto align-items-center">
                <div className="nav-item">
                  <Link
                    to=""
                    onClick={() => scrollToSection("about")}
                    className="nav-link"
                  >
                    About Us
                  </Link>
                  <Link to="/staking" className="nav-link">
                    Staking
                  </Link>
                  {/* <Link
                    to=""
                    onClick={() => scrollToSection("roadmap")}
                    className="nav-link"
                  >
                    Roadmap
                  </Link> */}

                  <Link
                    to="/"
                    onClick={() => scrollToSection("tokenomics")}
                    className="nav-link"
                  >
                    Allocation
                  </Link>
                  <Link
                    to=""
                    onClick={() => scrollToSection("faq")}
                    className="nav-link"
                  >
                    FAQ
                  </Link>
                  <Link onClick={downloadFiles} className="nav-link">
                    Whitepaper
                  </Link>
                </div>
                <div className="header-btn align-items-center">
                  <WalletModal />
                  {/* {isConnected ? (
                    <p onClick={() => handleDisconnect()}>connected</p>
                  ) : (
                    <Dropdown>
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="btn btn-disocnnect"
                      >
                        Connect Wallet
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {connectors.map((connector) => (
                          <Dropdown.Item
                            key={connector.uid}
                            onClick={() => connect({ connector })}
                          >
                            {connector.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  )} */}
                </div>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>
    </>
  );
};
export default Header;
